import img1 from '../images/ImageEight.png'
import img2 from '../images/ImageNine.png'
import img3 from '../images/ImageSeven.png'
import img4 from '../images/ImageSix.png'
import img5 from '../images/ImageTwo.png'
import img6 from '../images/ImageTwelve.png'

export const portfolio = [
    {
      id: 1,
      cover: img1,
    },
    {
      id: 2,
      cover: img2,
    },
    {
      id: 3,
      cover: img3,
    },
    {
      id: 4,
      cover: img4,
    },
    {
      id: 5,
      cover: img5,
    },
    {
      id: 6,
      cover: img6,
    },
  ]